<!-- @format -->

<a
	classList="ad-container hmf-mx-s hmf-mx-m-0 hmf-mb-xl hmf-mt-xl"
	hmf-text-link
	[linkURL]="content?.linkUrl"
	dataEm="pdp_nike_learnmore">
	<picture>
		<source
			srcset="assets/image/Nike_Dicks_Memberships.svg"
			media="(min-width: 768px)" />
		<img
			src="assets/image/Nike_Dicks_Memberships_Mobile.svg"
			alt="Nike Memberships"
			loading="lazy" />
	</picture>
</a>
